// contentful.js

import { createClient } from "contentful";
import { CONTENT_TYPES } from "./constants/contentTypes";
import { fromUrlFriendly } from "./utils/urlHelpers";
import localRuggedRedProducts from "./data/ruggedredProducts.json";

const RR_DEBUG = process.env.REACT_APP_RR_DEBUG === "true";
const isBrowser = typeof window !== "undefined";
const isBrowserLocalhost =
  isBrowser && (window.location.hostname === "localhost" || window.location.hostname === "127.0.0.1");
const PMST_API_BASE_OVERRIDE = process.env.REACT_APP_PMST_API_BASE_URL || "";
const DEFAULT_PMST_API_BASE_URL = "https://forza-product-managementsystem-b7c3ff8d3d2d.herokuapp.com";
const PMST_API_BASE_URL =
  PMST_API_BASE_OVERRIDE || (isBrowserLocalhost ? "http://localhost:5000" : DEFAULT_PMST_API_BASE_URL);
const PRODUCT_CONTENT_TYPES = new Set([CONTENT_TYPES.HOUSEHOLD, CONTENT_TYPES.PROFESSIONAL]);
const PRODUCT_IMAGE_FALLBACK_BY_ID = {
  rr_household_cleaner_degreaser:
    "https://images.ctfassets.net/hdznx4p7ef81/zDmOUnxX1GMkcpa5CKVqH/a166039f0a9c155884e5047193230b64/Rugged_Red_Cleaner_and_Degreaser_32_Ounces_Interlock_Dynamic_Sold_on_Amazon.png",
  rr_household_all_purpose_cleaner:
    "https://images.ctfassets.net/hdznx4p7ef81/3fAWyFSOx7sno0zOnRiwRf/b22931446d69780ed6866dc728b3f955/Rugged_Red_All_Purpose_Cleaner_32_Ounces_Interlock_Dynamic_Sold_on_Amazon.png",
  rr_household_glass_cleaner:
    "https://images.ctfassets.net/hdznx4p7ef81/4dpFK8EKdpbYJakUBPKKHq/21d3c4a225dae9a2ab22a5f67f1170ef/Rugged_Red_Glass_and_Mirror_Cleaner_32_Ounces_Interlock_Dynamic_Sold_on_Amazon.png",
  rr_household_odor_remover:
    "https://images.ctfassets.net/hdznx4p7ef81/QuewNrv2euP8kMhtb7AOq/a31eda50745439568a83df0b1822315d/Rugged_Red_Instant_Odor_Remover_32_Ounces_Interlock_Dynamic_Sold_on_Amazon.png",
  rr_household_spot_stain_remover:
    "https://images.ctfassets.net/hdznx4p7ef81/4SXrAg7hAzWyYe4rnz5gbj/d630e71d6b31c6487f27d93e4e5249c0/Rugged_Red_Spot_and_Stain_Remover_32_Ounces_Interlock_Dynamic_Sold_on_Amazon.png",
  rr_household_mold_mildew_stain_cleaner:
    "https://images.ctfassets.net/hdznx4p7ef81/23e65lnPbz0T30n7g2bHeC/f5eb087821539c8ad625e0f25ae293bf/Rugged_Red_Mold_and_Mildew_Stain_Cleaner_32_Ounces_Interlock_Dynamic_Sold_on_Amazon.png",
  rr_industrial_cleaner_degreaser:
    "https://images.ctfassets.net/hdznx4p7ef81/53RU0HYrJxqLQfdENURRoj/f34f2b2c4bac75cda997ec742e93b2ab/CD_Group_1.png",
  rr_industrial_all_purpose_cleaner:
    "https://images.ctfassets.net/hdznx4p7ef81/1lXhLDzCZrovwYz4pqbX4l/800a3dfcaabb530bc32d9f4e9f5551a6/APC_Group_1.png",
  rr_industrial_glass_cleaner:
    "https://images.ctfassets.net/hdznx4p7ef81/3JNLpG35eOmnjiQznnc55P/b0bf270a07eb8d6179e53e0a7fdaf131/GC_Group_1.png",
  rr_industrial_heavy_duty_degreaser:
    "https://images.ctfassets.net/hdznx4p7ef81/3whOX1q5cDMwLPB2WJM3ha/ce360aa4bd468fd6cccb16cb2641d2d3/HD_CD_Group_1.png",
  rr_industrial_foaming_glass_cleaner:
    "https://images.ctfassets.net/hdznx4p7ef81/41UxOj2Mpr3TwC3nJ1SVfW/c46bd3a13df6fecc7d2beccd468daa10/Aerosol_RR_Foaming_Glass_Cleaner.png",
  rr_industrial_instant_odor_remover:
    "https://images.ctfassets.net/hdznx4p7ef81/6J6jpWQRpnSXPRWSkQahaI/6d19a17959e94f9bbb072491717305a6/RR_Odor_Remover_B2B_Bottle.png",
  rr_industrial_mold_mildew_stain_cleaner:
    "https://images.ctfassets.net/hdznx4p7ef81/3u5Jmu9IFKDuVo1gsfG1AX/32b6e4914b150df594304ff6a1ab608e/RR_Mold_Mildew_B2B__White_Bottle.png",
  rr_industrial_spot_stain_remover:
    "https://images.ctfassets.net/hdznx4p7ef81/3lGAM5NLjw15deEQruYMMA/1ce47f51bdc264b571e88c892e23ad69/RR_Spot_Stain_B2B__White_Bottle.png",
  rr_industrial_carpet_cleaner:
    "https://images.ctfassets.net/hdznx4p7ef81/4WLygl6cPaGBS5lkLHUFiN/be31e5a1ad2e3978d04866dff1ebc3e4/RR_Carpet_Cleaner_1_Gal.png",
  rr_industrial_hard_surface_cleaner:
    "https://images.ctfassets.net/hdznx4p7ef81/1N28dmuB7Yuhi9rBYcFnSr/6a6f9aef4609b2342846699cf00d8ed2/RR_Hard_Surface_Cleaner_B2B_Bottle_2.png",
  rr_industrial_concrete_floor_cleaner:
    "https://images.ctfassets.net/hdznx4p7ef81/5waKbiTq49sQRNguNFLXpx/61a4800960549d97a032eb515339f601/RR_Concrete_Cleaner_1_Gal.png",
  rr_industrial_citrus_adhesive_remover:
    "https://images.ctfassets.net/hdznx4p7ef81/6SEfek35bml85tBMBMOiz6/b8f72cb0773d156243f183fbd19e6e4f/CAR_Group_1.png",
  rr_industrial_hand_cleaner:
    "https://images.ctfassets.net/hdznx4p7ef81/5DS2JTm2zUXYkfY4BSltzH/68b238551fa6f544a3fb86bdfb7b4c37/RR_Hand_Cleaner_1_Gal.png",
  rr_industrial_heavy_duty_hand_cleaner:
    "https://images.ctfassets.net/hdznx4p7ef81/1dMTPGSaSNuE0r7f4SLhjL/bb2e4e9ab100acb13cff0dc5d3eaaaa0/RR_Heavy_Duty_Hand_Cleaner_1_Gal.png",
  rr_industrial_tough_towels:
    "https://images.ctfassets.net/hdznx4p7ef81/rUGCiG1g5eewHJ0cg1qJb/fb80315382100e527b4fb9eaf8644518/RuggedRed_Tough_Towels_Mockup_1.png",
};

const spaceId = process.env.REACT_APP_CONTENTFUL_SPACE_ID;
const accessToken = process.env.REACT_APP_CONTENTFUL_DELIVERY_ACCESS_TOKEN;
const hasContentfulCredentials = Boolean(spaceId && accessToken);

const contentfulClient = hasContentfulCredentials
  ? createClient({
      space: spaceId,
      environment: process.env.REACT_APP_CONTENTFUL_ENVIRONMENT || "master",
      accessToken: accessToken,
    })
  : null;

if (!hasContentfulCredentials) {
  console.warn(
    "Contentful credentials not found. RR product data is served from PMST. Blog/news pages that require Contentful may be unavailable."
  );
}

const toSlug = (value = "") =>
  String(value)
    .toLowerCase()
    .trim()
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/^-+|-+$/g, "");

const parseJsonArrayString = (value = "") => {
  try {
    const parsed = JSON.parse(value);
    return Array.isArray(parsed) ? parsed : null;
  } catch {
    return null;
  }
};

const splitMixedString = (value = "", separators = [/\r?\n/, /[•]/, /[|]/]) => {
  let lines = [String(value || "")];
  separators.forEach((separator) => {
    lines = lines.flatMap((line) => String(line).split(separator));
  });
  return lines.map((line) => line.trim()).filter(Boolean);
};

const normalizeStringArray = (value, options = {}) => {
  const { splitPlus = false } = options;

  if (Array.isArray(value)) {
    return value.map((item) => String(item || "").trim()).filter(Boolean);
  }

  if (typeof value === "string") {
    const trimmed = value.trim();
    if (!trimmed) return [];

    const jsonArray = parseJsonArrayString(trimmed);
    if (Array.isArray(jsonArray)) {
      return jsonArray.map((item) => String(item || "").trim()).filter(Boolean);
    }

    const separators = splitPlus ? [/\r?\n/, /[•]/, /[|]/, /\s+\+\s+/] : [/\r?\n/, /[•]/, /[|]/];
    return splitMixedString(trimmed, separators);
  }

  return [];
};

const normalizeNameKey = (value = "") =>
  String(value)
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, " ")
    .trim();

const dedupeStringArray = (values = []) => {
  const seen = new Set();
  const result = [];

  values.forEach((value) => {
    const text = String(value || "").trim();
    if (!text) return;
    const canonical = text
      .toLowerCase()
      .replace(/gallon/g, "gal")
      .replace(/[^a-z0-9]+/g, "");
    if (seen.has(canonical)) return;
    seen.add(canonical);
    result.push(text);
  });

  return result;
};

const MADE_IN_AMERICA_ASTERISK_IDS = new Set([
  "rr_household_all_purpose_cleaner",
  "rr_household_cleaner_degreaser",
  "rr_household_glass_cleaner",
  "rr_industrial_all_purpose_cleaner",
  "rr_industrial_cleaner_degreaser",
  "rr_industrial_glass_cleaner",
]);

const withMadeInAmericaAsterisk = (description = "", productId = "") => {
  if (!MADE_IN_AMERICA_ASTERISK_IDS.has(productId)) return description;
  if (description.includes("USA*") || description.includes("USA *")) return description;
  return description
    .replace(/made in the usa\b/gi, "made in the USA*")
    .replace(/made in usa\b/gi, "made in USA*");
};

const resolveProductImageUrl = (product) => {
  const fallbackById = PRODUCT_IMAGE_FALLBACK_BY_ID[product?.product_id] || "";
  if (typeof product?.image === "string" && product.image.trim()) {
    const image = product.image.trim();
    if (image.startsWith("http://") || image.startsWith("https://")) {
      return image;
    }
    if (image.startsWith("/")) {
      // Prefer known stable image CDN assets over PMST relative image paths.
      if (fallbackById) {
        return fallbackById;
      }
      if (PMST_API_BASE_URL) {
        return `${PMST_API_BASE_URL}${image}`;
      }
      return fallbackById || image;
    }
    return image;
  }

  if (product?.product_id && PMST_API_BASE_URL) {
    return `${PMST_API_BASE_URL}/product-images/ruggedred/${product.product_id}.webp`;
  }

  return fallbackById;
};

const withFieldFallbacks = (products = []) => {
  const bestByName = new Map();

  for (const product of products) {
    const key = normalizeNameKey(product?.full_name || product?.name || "");
    if (!key) continue;

    const benefits = normalizeStringArray(product?.benefits);
    const applications = normalizeStringArray(product?.applications);
    const howToUse = normalizeStringArray(product?.how_to_use);
    const sizing = normalizeStringArray(product?.sizing, { splitPlus: true });
    if (!benefits.length && !applications.length && !howToUse.length && !sizing.length) continue;

    const score = product?.industry === "industrial_industry" ? 2 : 1;
    const existing = bestByName.get(key);
    if (!existing || score > existing.score) {
      bestByName.set(key, { benefits, applications, howToUse, sizing, score });
    }
  }

  return products.map((product) => {
    const key = normalizeNameKey(product?.full_name || product?.name || "");
    const fallback = bestByName.get(key);
    if (!fallback) return product;

    const benefits = normalizeStringArray(product?.benefits);
    const applications = normalizeStringArray(product?.applications);
    const howToUse = normalizeStringArray(product?.how_to_use);
    const sizing = normalizeStringArray(product?.sizing, { splitPlus: true });

    return {
      ...product,
      benefits: benefits.length ? benefits : fallback.benefits,
      applications: applications.length ? applications : fallback.applications,
      how_to_use: howToUse.length ? howToUse : fallback.howToUse,
      sizing: sizing.length ? sizing : fallback.sizing,
    };
  });
};

const LOCAL_FALLBACK_PRODUCTS = withFieldFallbacks(localRuggedRedProducts);

const toContentfulLikeProduct = (product) => {
  const productTitle = product?.full_name || product?.name || "";
  const imageUrl = resolveProductImageUrl(product);
  const keyBenefits = normalizeStringArray(product?.benefits);
  const keyBenefitsWithFallback =
    keyBenefits.length > 0 ? keyBenefits : normalizeStringArray(product?.description ? [product.description] : []);
  const howToUseSteps = normalizeStringArray(product?.how_to_use);
  const applications = normalizeStringArray(product?.applications);
  const applicationsWithFallback =
    applications.length > 0 ? applications : normalizeStringArray(product?.description ? [product.description] : []);
  const sizing = dedupeStringArray(normalizeStringArray(product?.sizing, { splitPlus: true }));
  const productImageFallback = PRODUCT_IMAGE_FALLBACK_BY_ID[product?.product_id] || "";
  const shortDescription = withMadeInAmericaAsterisk(product?.description || "", product?.product_id || "");

  return {
    sys: { id: product?.product_id || toSlug(productTitle) },
    fields: {
      productTitle,
      slogan: keyBenefitsWithFallback[0] || "",
      productImage: { fields: { file: { url: imageUrl } } },
      productHeroImage: { fields: { file: { url: imageUrl } } },
      productImageFallback,
      shortProductDescription: shortDescription,
      keyBenefits: keyBenefitsWithFallback,
      applications: applicationsWithFallback,
      howToUse: howToUseSteps.join("\n"),
      how_to_use: howToUseSteps,
      bottleSizing: sizing.join(" + "),
      buyNowButtonUrl: "Coming Soon!",
      price: null,
      url: product?.url || "",
      productId: product?.product_id || "",
      industry: product?.industry || "",
    },
  };
};

const getIndustryForContentType = (contentType) =>
  contentType === CONTENT_TYPES.PROFESSIONAL ? "industrial_industry" : "household_industry";

const fetchPmstRawProducts = async () => {
  try {
    const response = await fetch(`${PMST_API_BASE_URL}/api/products?published=true`);
    if (!response.ok) {
      throw new Error(`Failed to fetch PMST products: ${response.status}`);
    }

    const payload = await response.json();
    const fromDb = Array.isArray(payload)
      ? payload.filter((product) => String(product?.brand || "").toLowerCase() === "rugged_red")
      : [];

    if (fromDb.length > 0) {
      if (RR_DEBUG) {
        console.info("[RR DEBUG] Using PMST DB products.", { count: fromDb.length });
      }
      return withFieldFallbacks(fromDb);
    }

    const jsonResponse = await fetch(`${PMST_API_BASE_URL}/api/products/ruggedred-json`);
    if (!jsonResponse.ok) {
      if (RR_DEBUG) {
        console.warn("[RR DEBUG] PMST ruggedred-json endpoint unavailable. Falling back to bundled data.", {
          status: jsonResponse.status,
        });
      }
      return LOCAL_FALLBACK_PRODUCTS;
    }

    const jsonPayload = await jsonResponse.json();
    const fromJson = Array.isArray(jsonPayload?.products) ? jsonPayload.products : [];
    if (RR_DEBUG) {
      console.info("[RR DEBUG] Using PMST ruggedred-json products.", { count: fromJson.length });
    }
    return withFieldFallbacks(fromJson);
  } catch (error) {
    console.warn("PMST API unavailable, using bundled RuggedRed products.", error);
    return LOCAL_FALLBACK_PRODUCTS;
  }
};

const requireContentfulClient = () => {
  if (!contentfulClient) {
    throw new Error(
      "Contentful credentials are required for this page. Product pages now use PMST, but blog/news still require Contentful."
    );
  }
  return contentfulClient;
};

export const fetchProducts = async (contentType = CONTENT_TYPES.HOUSEHOLD) => {
  try {
    const industry = getIndustryForContentType(contentType);
    const rawProducts = await fetchPmstRawProducts();
    return rawProducts
      .filter((product) => product?.industry === industry)
      .map(toContentfulLikeProduct)
      .reverse();
  } catch (error) {
    console.error(`Error fetching PMST products for ${contentType}:`, error);
    return [];
  }
};

export const fetchProductByTitle = async (productTitle, contentType = CONTENT_TYPES.HOUSEHOLD) => {
  if (!productTitle) return null;

  const searchSlug = toSlug(productTitle);
  const searchTitle = toSlug(fromUrlFriendly(productTitle));
  const products = await fetchProducts(contentType);

  return (
    products.find((item) => {
      const itemTitleSlug = toSlug(item?.fields?.productTitle);
      const itemIdSlug = toSlug(item?.sys?.id);
      const itemUrl = String(item?.fields?.url || "");
      const itemUrlSlug = toSlug(itemUrl.split("/").filter(Boolean).pop() || "");
      return (
        itemTitleSlug === searchSlug ||
        itemTitleSlug === searchTitle ||
        itemIdSlug === searchSlug ||
        itemIdSlug === searchTitle ||
        itemUrlSlug === searchSlug ||
        itemUrlSlug === searchTitle
      );
    }) || null
  );
};

export const fetchProductById = async (productId) => {
  const rawProducts = await fetchPmstRawProducts();
  const found = rawProducts.find((product) => product?.product_id === productId);
  return found ? toContentfulLikeProduct(found) : null;
};

export const fetchB2BProducts = async () => fetchProducts(CONTENT_TYPES.PROFESSIONAL);

export const fetchBlogPosts = async () => {
  const client = requireContentfulClient();
  const response = await client.getEntries({
    content_type: CONTENT_TYPES.BLOG_POST,
    order: "-fields.publishDate",
  });
  return response.items || [];
};

export const fetchBlogPostByTitle = async (title) => {
  const client = requireContentfulClient();
  const searchTitle = String(title || "").replace(/-/g, " ");
  const response = await client.getEntries({
    content_type: CONTENT_TYPES.BLOG_POST,
    query: searchTitle,
  });

  if (!response.items?.length) return null;
  const matchingPost = response.items.find(
    (post) => post?.fields?.title?.toLowerCase() === searchTitle.toLowerCase()
  );
  return matchingPost || response.items[0];
};

export const fetchNewsArticleByTitle = async (title) => {
  if (!title) return null;
  const client = requireContentfulClient();

  const exact = await client.getEntries({
    content_type: "newsArticle-2",
    "fields.title": title,
    limit: 1,
  });
  if (exact.items?.length) return exact.items[0];

  const partial = await client.getEntries({
    content_type: "newsArticle-2",
    "fields.title[match]": title,
    limit: 1,
  });
  return partial.items?.[0] || null;
};

const client = {
  getEntries: async (query = {}) => {
    const contentType = query?.content_type;
    if (PRODUCT_CONTENT_TYPES.has(contentType)) {
      const items = await fetchProducts(contentType);
      return { items };
    }

    return requireContentfulClient().getEntries(query);
  },
  getEntry: async (entryId) => {
    const product = await fetchProductById(entryId);
    if (product) return product;
    return requireContentfulClient().getEntry(entryId);
  },
};

export default client;
